<div class="charts-wrapper">
	<div class="row"
		*ngIf="chartData">
		<div class="col-12 chart-container"
			id="fading-div"
			*ngIf="chartType === CHARTTYPE.PIE && show; else loader">
			<app-chart type="doughnut"
				[data]="chartData"></app-chart>
		</div>
		<ng-template #loader>
			<formio-loader></formio-loader>
		</ng-template>
	</div>
</div>
<hr>